/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

// TODO: should be in a env config
export const KEY_API = 'AIzaSyBBQKAvuPLxgX7ERfHYMa2NRpP1WCGomiE';

const computeMapUrl = (type, address, template) => {
  const mapHeight = template !== 'top' ? 350 : 200;
  // prettier-ignore
  return  type === 'static' ?
    `https://maps.googleapis.com/maps/api/staticmap?key=${KEY_API}&center=${address}&markers=${address}&size=640x${mapHeight}&scale=2` :
    `https://www.google.com/maps/embed/v1/place?key=${KEY_API}&q=${address}`;
};

export default class Map extends PureComponent {
  render() {
    const { address, height, mapType = 'dynamic', template } = this.props;

    const mapUrl = computeMapUrl(mapType, address, template);

    return (
      <div>
        {mapType === 'dynamic' && (
          <iframe title="google_maps" width="100%" height={height} src={mapUrl} />
        )}
        {mapType === 'static' && <img src={mapUrl} alt="map" width="100%" />}
      </div>
    );
  }
}

Map.defaultProps = {
  address: 'Champ de Mars, 5 Avenue Anatole France, 75007 Paris',
  height: 80,
};

Map.propTypes = {
  address: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
